/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from NumericRegister.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace NumericRegister.
 * @hassoydeltemplate {PageRenderer.RegisterFieldType.idom}
 * @public
 */

goog.module('NumericRegister.incrementaldom');

goog.require('soy');
var soyIdom = goog.require('soy.idom');

var $templateAlias1 = Soy.getTemplate('Numeric.incrementaldom', 'render');


/**
 * @param {Object<string, *>=} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function __deltemplate_s2876_3e23f29f(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  opt_data = opt_data || {};
  $templateAlias1(opt_data, null, opt_ijData);
}
exports.__deltemplate_s2876_3e23f29f = __deltemplate_s2876_3e23f29f;
if (goog.DEBUG) {
  __deltemplate_s2876_3e23f29f.soyTemplateName = 'NumericRegister.__deltemplate_s2876_3e23f29f';
}
soy.$$registerDelegateFn(soy.$$getDelTemplateId('PageRenderer.RegisterFieldType.idom'), 'numeric', 0, __deltemplate_s2876_3e23f29f);

templates = exports;
return exports;

});

export { templates };
export default templates;
/* jshint ignore:end */
